import { devices_settings, devices_status } from 'src/stores/device-runtime/status';
import { getBatteryIconStatus } from '../virtual_helpers/virtual_icons_helpers';
import { convertToUnit } from '../units_helpers';
//Types
import type { Device } from 'src/types/Device';

export function isBluSoilSensor(deviceType: string) {
	if (typeof deviceType === 'undefined') return false;
	return /^(SBMS-001A)$/.test(deviceType || '');
}

export const getSoilSensorDeviceStatus = (device: Device) => {
	const deviceStatus = devices_status.getByRealId(device?.id);
	const deviceSettings = devices_settings.getByRealId(device?.id);
	const interface_data = [];
	if (!device || !deviceStatus || !deviceSettings) {
		return interface_data;
	}

	const moisture = deviceStatus?.['moisture:0']?.value ?? 0;
	interface_data.push({
		name: 'moisture',
		icon: 'fas fa-droplet-percent',
		value: convertToUnit(moisture, '%'),
		mainLabel: true,
		main: true,
	});

	const tempComponent = 'temperature:0';
	const tempUnit = device?.ht_ui?.temperature_unit || 'C';
	const temperature = deviceStatus[tempComponent]?.[`t${tempUnit}`] ?? 0;
	interface_data.push({
		name: 'temperature',
		value: convertToUnit(temperature, `°${tempUnit}`),
		icon: 'fas fa-thermometer-three-quarters',
	});

	const batteryPercent = deviceStatus?.['devicepower:0']?.battery?.percent ?? 0;
	const batteryIcon = getBatteryIconStatus(batteryPercent);
	interface_data.push({
		name: 'battery',
		icon: batteryIcon.icon,
		value: `${batteryPercent} %`,
		...(batteryIcon.iconStyle && { iconStyle: batteryIcon.iconStyle }),
		...(batteryIcon.iconColor && { iconColor: batteryIcon.iconColor }),
	});

	return interface_data;
};
